// extracted by mini-css-extract-plugin
export default {"page":"HgkNuQ","wixLogo":"d4VdEc","content":"gUL5Fo","frame":"k_7HFF","title":"nGGaK9"};